// extracted by mini-css-extract-plugin
module.exports = {"parent_container":"salespro-app-for-retailers_parent_container__j2xyg"};